<div class="sm-textarea-field">
  @if (label) {
    <span class="sm-textarea-field__label">{{ label }}</span>
  }

  <div class="sm-textarea" [class.sm-textarea--invalid]="invalid">
    <ion-textarea
      [value]="value"
      [placeholder]="placeholder"
      [attr.aria-label]="ariaLabel || label || null"
      [readonly]="readonly"
      [disabled]="disabled"
      [autoGrow]="autoGrow"
      (ionInput)="handleInput($event)"
      (ionBlur)="handleBlur()">
    </ion-textarea>
  </div>
</div>

@if (errorText) {
  <p class="sm-textarea-field__error">{{ errorText }}</p>
}
